import { render, staticRenderFns } from "./blogtags.vue?vue&type=template&id=314db298&"
import script from "./blogtags.vue?vue&type=script&lang=js&"
export * from "./blogtags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('314db298')) {
      api.createRecord('314db298', component.options)
    } else {
      api.reload('314db298', component.options)
    }
    module.hot.accept("./blogtags.vue?vue&type=template&id=314db298&", function () {
      api.rerender('314db298', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24CwhT4Hl8rws/JS/comp/blogtags.vue"
export default component.exports